<template>
  <div class="headerContainer">
    <header>
      <div class="container-fluid">
        <div class="header d-lg-flex justify-content-between align-items-center py-3 px-sm-3">
          <!-- logo -->
          <div id="logo">
            <img src="../../assets/images/logo-new.png" :alt="$t('headContent.title')" width="134px" />
            <div class="v-line"></div>
            <div class="logo_text">
              <span class="logo_strong_text">{{
                $t("headContent.title")
              }}</span>
              <span class="logo_weak_text">{{
                $t("headContent.subTitle")
              }}</span>
            </div>
          </div>
          <!-- //logo -->
          <!-- nav -->
          <div class="nav_w3ls">
            <nav>
              <label for="drop" class="toggle">Menu</label>
              <input type="checkbox" id="drop" />
              <ul class="menu">
                <li>
                  <a @click="navigate('index')" :class="{ active: $route.path === '/index' }">{{ $t("navigateBar.home")
                  }}</a>
                </li>
                <li>
                  <a @click="navigate('recheck-ai')" :class="{ active: $route.path === '/recheck-ai' }">ReCheck</a>
                </li>
                <li>
                  <label for="drop-2" class="toggle toogle-2">Product&amp;Service
                    <span class="fa fa-angle-down" aria-hidden="true"></span>
                  </label>
                  <a href="#">{{ $t("navigateBar.productService") }}
                    <span class="fa fa-angle-down" aria-hidden="true"></span></a>
                  <input type="checkbox" id="drop-2" />
                  <ul>
                    <li>
                      <a href="https://www.openjournalsystems.my/" class="drop-text" target="_blank">{{
                        $t("navigateBar.ojsSupport") }}</a>
                    </li>
                    <li>
                      <a @click="navigate('Journal-Evaluation-and-Management')" :class="{
                        active:
                          $route.path ===
                          '/Journal-Evaluation-and-Management',
                      }" class="drop-text">{{ $t("navigateBar.journalEvaluationManagement") }}</a>
                    </li>
                    <li>
                      <a @click="navigate('Impact-Factor-Managment')" :class="{
                        active: $route.path === '/Impact-Factor-Managment',
                      }" class="drop-text">{{ $t("navigateBar.impactFactorManagment") }}</a>
                    </li>
                    <li>
                      <a @click="navigate('Qualified-Author-Targeting')" :class="{
                        active: $route.path === '/Qualified-Author-Targeting',
                      }" class="drop-text">{{ $t("navigateBar.qualifiedAuthorTargeting") }}</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <label for="drop-3" class="toggle toogle-2">Open Data
                    <span class="fa fa-angle-down" aria-hidden="true"></span>
                  </label>
                  <a href="#">{{ $t("navigateBar.openData") }}
                    <span class="fa fa-angle-down" aria-hidden="true"></span></a>
                  <input type="checkbox" id="drop-3" />
                  <ul>
                    <li>
                      <a @click="navigate('Updated-Journal-Lists')" :class="{
                        active: $route.path === '/Updated-Journal-Lists',
                      }" class="drop-text">{{ $t("navigateBar.updatedJournalLists") }}</a>
                    </li>
                    <li>
                      <a @click="navigate('Dynamic-Journal-Impact-Factor')" :class="{
                        active:
                          $route.path === '/Dynamic-Journal-Impact-Factor',
                      }" class="drop-text">{{ $t("navigateBar.dynamicJournalImpactFactor") }}</a>
                    </li>
                  </ul>
                </li>
                <li v-if="language === 'zh'">
                  <a @click="navigate('Blog')" :class="{ active: $route.path === '/Blog' }" class="drop-text">{{
                    $t("navigateBar.blog") }}</a>
                </li>
                <li>
                  <a @click="navigate('Contact-Us')" :class="{ active: $route.path === '/Contact-Us' }">{{
                    $t("navigateBar.contactUs") }}</a>
                </li>
              </ul>
            </nav>
          </div>
          <!-- //nav -->
          <div class="d-flex mt-lg-1 mt-sm-2 mt-3 justify-content-center switchLanguage">
            <a class="dwn-w3ls btn" style="width: 58px" @click="changeLang(language === 'zh' ? 'en' : 'zh')">
              <span>{{
                language === "zh" ? "EN" : "中文"
              }}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "HeaderContainer",
  data() {
    return {
      language: localStorage.getItem("lang") || "zh",
      isRendered: true,
    };
  },
  created() {
    this.$i18n.locale = this.language;
  },
  methods: {
    navigate(path) {
      this.$router.push({ path: path });
    },
    // 切换语言
    changeLang(lang) {
      if (this.$i18n.locale == "en") {
        localStorage.setItem("locale", "zh");
        this.$i18n.locale = 'zh'
        this.$message({
          message: "切换为中文！",
          type: "success",
        });
        localStorage.setItem("lang", "zh");
        location.reload();
      } else if (this.$i18n.locale == "zh") {
        localStorage.setItem("locale", "en");
        this.$i18n.locale = 'en'
        this.$message({
          message: "Switch to English!",
          type: "success",
        });
        localStorage.setItem("lang", "en");
        location.reload();
      }

    },

  },
};
</script>

<style lang="scss" scoped></style>
